import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App.jsx";
import { AuthProvider } from "./auth/AuthContext.jsx";
import "./i18n";   // initialises i18next before any component renders
import "./index.css";

// Whole app lives at /ai-visibility/. React Router's `basename` keeps
// every <Link to="..."> and useNavigate() call relative to that prefix
// — components stay portable and we never hard-code the mount point.
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter basename="/ai-visibility">
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
